import Repository from '@/repositories/marketing'
const resource = '/contents'

export default {
    fetch (config) {
        return Repository.get(`${resource}.json`, config)
    },
    preview (contentId, config) {
        return Repository.get(`${resource}/${contentId}/preview.json`, config)
    },
    delete (contentId) {
        return Repository.delete(`${resource}/${contentId}.json`)
    },
    bulkDelete (config) {
        return Repository.delete(`${resource}/bulk_delete.json`, config)
    },
    /**
    * @description For get a single content detail
    * @used Email Content Dashboard
    * @return Axios Instance
    */
    show (contentId, config) {
        return Repository.get(`${resource}/${contentId}.json`, config)
    },
    fetchEmailClients (contentId, config) {
        return Repository.post(`${resource}/${contentId}/email_on_acid_test.json`, config)
    },
    archiveRecord (id, config) {
        return Repository.post(`${resource}/${id}/archive_record.json`, config)
    },
    edit (contentId, config) {
        return Repository.get(`${resource}/${contentId}/edit.json`, config)
    },
    structuredContentPreview (payload, config) {
        return Repository.post(`${resource}/structured_content_preview.json`, payload, config)
    },
    save (payload, config) {
        return Repository.post(`${resource}.json`, payload, config)
    },
    update (contentId, payload, config) {
        return Repository.put(`${resource}/${contentId}.json`, payload, config)
    },
    checkRecordInUse (id, config) {
        return Repository.get(`${resource}/${id}/check_modules_in_use.json`, config)
    },
    validateUrl(config) {
        return Repository.get(`${resource}/load_from_url.json`, config)
    },
    validateName(config){
        return Repository.get(`${resource}/validate_name.json`, config);
    },
    getLibraryList(config){
        return Repository.get(`${resource}/get_templates.json`,config)
    },
    getTemplateDetails(config){
        return Repository.get(`${resource}/get_details_of_template.json`, config)
    }
}
